export default __webpack_public_path__ + "static/media/img6.7cf13995.jpg";